<!--
 * Searchbar
 * --------------------
 * Renders the searchbar.
 *
 * @author  Harvinder Singh <harvinder@maropost.com>
 * @created 2025-10-24
 -->

<template>
  <div class="search-bar">
    <TheSearchBar 
      :show="showSearchBar"
      :queryParamName="searchQueryParamName"
    />
  </div>
</template>

<script setup lang="ts">
  import { TheSearchBar } from '@maropost-ui/liquidsky-ui'
  import { computed, ref } from 'vue'
  import { useRoute } from 'vue-router'

  const showSearchBar = ref<boolean>(true)


  /**
 * ------------------------------------------------------------
 * Key   = Path prefix in the URL (e.g., /accounts, /commerce, /service)
 * Value = Product name string used for search query parameters
 */
const mfeMap: Record<string, string> = {
  accounts: "name",
  commerce: "q",
  service: "name",
}

const route = useRoute()

/**
 * Dynamically compute the search query parameter name
 * ------------------------------------------------------------
 * - Looks at the current browser `window.location.pathname`
 * - Matches the path against our `mfeMap`
 * - Returns the correct product key (e.g., "marketing", "commerce", "service")
 * - Falls back to "name" if no match is found
 *
 */

 const searchQueryParamName = computed<string>(() => {
    const key = Object.keys(mfeMap).find(prefix =>
      route.path.startsWith(`/${prefix}`)
    )
    return key ? mfeMap[key] : "name"
  })
</script>

<style scoped >
.search-bar {
  margin-left: 50px;
}
</style>